module.exports = __webpack_public_path__ + "static/media/PolihireLogo.e38189ff.png";